export function clonePoint(point) {

  const _point = {
    path: [...point.path],
    offset: point.offset
  };

  return _point;

}

export function cloneAnchor(anchor) {

  return clonePoint(anchor);

}

export function cloneFocus(focus) {

  return clonePoint(focus);

}